import {
  voucherService
} from '../service/voucherService';

import * as ls from 'local-storage';
import * as Cookie from 'js-cookie';

const voucher = {
  namespaced: true,
  state: {
    code: '',
  },
  mutations: {
    prepareVoucher(state, code) {
      state.code = code;
    },
    saveVoucher(state, code) {
      ls.set('voucher_code', code);
    }
  },
  actions: {
    async checkVoucher(commit, code) {
      const data = await voucherService.validateVoucher(code);
      return data;
    },
    async applyVoucher({ commit }, params) {
      const data = await voucherService.applyVoucher(
        params.code,
        params.delivery_weekday,
        params.shipping_run,
        params.recipe_ids,
        params.portion_count);
      return data;
    },
    prepareVoucher({ commit, dispatch }, code) {
      commit('prepareVoucher', code);
      dispatch('saveVoucher', code);
    },
    loadVoucher({ commit }) {
      const stored = ls.get('voucher_code');
      const cookie = Cookie.get('voucher_code');
      if (cookie) {
        commit('prepareVoucher', cookie);
      } else if (stored) {
        commit('prepareVoucher', stored);
      }
    },
    saveVoucher({ commit }, code) {
      commit('saveVoucher', code);
    }
  }
}

export default voucher;